/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2023-05-08 11:33:04
 */

 import * as Vue from "vue-tsx-support";
 import {Component, Prop} from 'vue-property-decorator'
 import "vue-tsx-support/enable-check"
 import Modal from "src/types/iview/Modal";
 import Button from "src/types/iview/Button";
 import Input from "src/types/iview/Input";
 import {Toast} from "src/util/toast";
 import {modalFactory} from "src/util/vueExtend";
 import UserConfigApi from 'src/pages/systemConfig/userConfig/api/userConfigApi';
 
 export namespace UpdateOpinionFeedbackVOI {
     export interface PropsI {
         saveSuccess? (): void
 
         cancel? (): void
     }
 
     export interface FormDataI {
        feedback_content: string //反馈内容
     }
 }
 
 @Component
 class UpdateOpinionFeedbackModal extends Vue.Component<UpdateOpinionFeedbackVOI.PropsI> {
     @Prop({
         type: Function
     })
     cancel!: () => void
 
     @Prop({
         type: Function
     })
     saveSuccess!: () => void
 
     visible: boolean = false
 
     loading: boolean = false
 
     formData: UpdateOpinionFeedbackVOI.FormDataI = {
        feedback_content: '',
     }
     rules: any = {
     }
 
     close () {
         this.cancel && this.cancel()
         this.closeModal()
     }
 
     closeModal() {
         this.visible = false
         this.$emit('close', false)
     }
 
     async save () {
         if(!await this.$validate('formValidate')) {
             return
         }
         this.loading = true
         let {code} = await UserConfigApi.updateOpinionFeedback(this.formData.feedback_content)
         this.loading = false
         if (code === 0) {
             Toast.success('意见反馈成功！')
             this.saveSuccess()
             this.closeModal()
         }
     }
 
     render (h) {
         return (
             <Modal
                 title="意见反馈"
                 width="650"
                 v-model={this.visible}
                 mask-closable={false}
                 on-on-cancel={this.close}
             >
                 <i-form ref="formValidate" labelWidth={0} model={this.formData} rules={this.rules}>
                         <form-item label="" prop="feedback_content" style="display: inline-block;width:100%;height:200px" required>
                            <Input placeholder="请输入意见反馈" v-model={this.formData.feedback_content} type="textarea"/>
                         </form-item>
                 </i-form>
                 <div slot="footer">
                     <Button type="primary" ghost on-click={this.close}>取消</Button>
                     <Button type="primary" on-click={this.save} loading={this.loading}>提交</Button>
                 </div>
             </Modal>
         );
     }
 }
 
 export default function alertUpdateOpinionFeedbackModal (): Promise<boolean> {
         return new Promise((resolve, reject) => {
             modalFactory<UpdateOpinionFeedbackVOI.PropsI>(UpdateOpinionFeedbackModal)({
                 saveSuccess () {
                     resolve(true)
                 },
                 cancel () {
                     resolve(false)
                 }
             })
         })
     }
 